import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

import LandlordProtectedRoute from 'src/components/auth/LandlordProtectedRoute';
import ActivityPage from 'src/pages/landlord/activity/ActivityPage';
import ConversationsInboxPage from 'src/pages/landlord/conversations/ConversationsInboxPage';
import ConversationsSearchPage from 'src/pages/landlord/conversations/ConversationsSearchPage';
import LeadsPage from 'src/pages/landlord/leads/LeadsPage';
import LeadMessagesPage from 'src/pages/landlord/leads/messages/LeadMessagesPage';

const PropertiesPage = lazy(() => import('src/pages/landlord/properties/PropertiesPage'));
const SettingsPage = lazy(() => import('src/pages/landlord/settings/SettingsPage'));
const PlaybooksPage = lazy(() => import('src/pages/landlord/playbooks/index/PlaybooksPage'));
const NewPlaybookPage = lazy(() => import('src/pages/landlord/playbooks/new/NewPlaybookPage'));
const EditPlaybookPage = lazy(() => import('src/pages/landlord/playbooks/edit/EditPlaybookPage'));
const ToursPage = lazy(() => import('src/pages/landlord/tours/ToursPage'));
const AnalyticsPage = lazy(() => import('src/pages/landlord/analytics/AnalyticsPage'));
const LandlordTeam = lazy(() => import('src/pages/landlord/team/LandlordTeam'));
const ListingsPage = lazy(() => import('src/pages/landlord/listings/ListingsPage'));
const SnippetsPage = lazy(() => import('src/pages/landlord/snippets/SnippetsPage'));
import TestErrorBoundaryPage from 'src/pages/test-error-boundary/TestErrorBoundaryPage';
const InboxesPage = lazy(() => import('src/pages/landlord/inboxes/InboxesPage'));
const RootPage = lazy(() => import('src/pages/landlord/root/RootPage'));
import FlaggedPage from 'src/pages/landlord/FlaggedPage';
import { EFeatureFlag } from 'src/utils/feature-flags';

/**
 * Routes for the landlord protected pages.
 * They have to be nested under the `/landlord/inner` route.
 */
export const getLandlordProtectedRoutes = (enabledFeatureFlags?: EFeatureFlag[]) => {
    return [
        <Route key="root" path="root" element={<LandlordProtectedRoute><RootPage /></LandlordProtectedRoute>} />,
        <Route key="analytics" path="analytics" element={<LandlordProtectedRoute><AnalyticsPage /></LandlordProtectedRoute>} />,
        <Route key="playbooks" path="playbooks" element={<LandlordProtectedRoute><PlaybooksPage /></LandlordProtectedRoute>} />,
        <Route key="playbooks/new" path="playbooks/new" element={<LandlordProtectedRoute><NewPlaybookPage /></LandlordProtectedRoute>} />,
        <Route key="playbooks/:id" path="playbooks/:id" element={<LandlordProtectedRoute><EditPlaybookPage /></LandlordProtectedRoute>} />,
        <Route key="properties" path="properties" element={<LandlordProtectedRoute><PropertiesPage /></LandlordProtectedRoute>} />,
        <Route key="properties/listings" path="properties/listings" element={<LandlordProtectedRoute><ListingsPage /></LandlordProtectedRoute>} />,
        <Route key="inboxes" path="inboxes" element={<LandlordProtectedRoute><InboxesPage /></LandlordProtectedRoute>} />,
        <Route key="inboxes/:id" path="inboxes/:id" element={<LandlordProtectedRoute><ConversationsInboxPage /></LandlordProtectedRoute>} />,

        ...(enabledFeatureFlags?.includes(EFeatureFlag.FEATURE_FLAG_ROUTE) ? [
            <Route key="flagged" path="flagged" element={<LandlordProtectedRoute><FlaggedPage /></LandlordProtectedRoute>} />,
        ] : []),


        <Route key="messages/from-lead" path="messages/from-lead/*" element={<LandlordProtectedRoute><LeadMessagesPage /></LandlordProtectedRoute>} />,
        <Route key="archive" path="archive" element={<LandlordProtectedRoute><ConversationsSearchPage /></LandlordProtectedRoute>} />,
        <Route key="tours" path="tours" element={<LandlordProtectedRoute><ToursPage /></LandlordProtectedRoute>} />,
        <Route key="settings" path="settings" element={<LandlordProtectedRoute><SettingsPage /></LandlordProtectedRoute>} />,
        <Route key="leads/all" path="leads/all" element={<LandlordProtectedRoute><LeadsPage /></LandlordProtectedRoute>} />,
        <Route key="team" path="team" element={<LandlordProtectedRoute><LandlordTeam /></LandlordProtectedRoute>} />,
        <Route key="test-error-boundary" path="test-error-boundary" element={<LandlordProtectedRoute><TestErrorBoundaryPage /></LandlordProtectedRoute>} />,
        <Route key="snippets" path="snippets" element={<LandlordProtectedRoute><SnippetsPage /></LandlordProtectedRoute>} />,
        <Route key="activity" path="activity" element={<LandlordProtectedRoute><ActivityPage /></LandlordProtectedRoute>} />,
    ];
};
